import React from 'react';
import RenderBreakpoint from '../common/breakpoints/RenderBreakpoint';
import AppDrawerComplex from './menu/drawer/complex/AppDrawerComplex';
import AppDrawerSimple from './menu/drawer/simple/AppDrawerSimple';
import PropTypes from 'prop-types';

const AppMenuMain = React.memo(({ open, onClose, menuDefinition }) => {
  
  return (
    <RenderBreakpoint mobile desktop>
      {({ isMobile, isDesktop }) => (
        <React.Fragment>
          {isMobile && (
            <AppDrawerSimple
              menuDefinition={menuDefinition}
              open={open}
              onClose={onClose}
            />
          )}
          
          {isDesktop && (
            <AppDrawerComplex
              modal={false}
              menuDefinition={menuDefinition}
              open={false}
              onClose={onClose}
            />
          )}
        </React.Fragment>
      )}
    </RenderBreakpoint>
  );
});

AppMenuMain.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  menuDefinition: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default AppMenuMain;
